<template>
  <div class="about-page">
    <section class="about-hero">
      <div class="about-hero-content">
        <h1>About AIR Surgical</h1>
        <p class="lead">
          Advancing minimally invasive cancer care with in-scanner robotics.
        </p>
      </div>
    </section>

    <section class="about-story">
      <div class="about-story-inner">
        <h2>Our mission</h2>
        <p>
          Air Surgical is developing an in-scanner robotic system for image-guided needle placement. We're focused on the accuracy and workflow physicians need so more patients can access minimally invasive treatment. Our approach has been evaluated in preclinical studies. <router-link to="/technology">See how it works</router-link> or <router-link to="/contact">get in touch</router-link> to learn more.
        </p>
      </div>
    </section>

    <section class="about-cta">
      <router-link to="/contact" class="btn">Get in touch</router-link>
    </section>
  </div>
</template>

<script>
export default {
  name: 'AboutPage',
  mounted() {
    document.title = 'About | Air Surgical';
  }
};
</script>

<style scoped>
.about-page {
  padding-top: 70px;
}

.about-hero {
  background: linear-gradient(135deg, #1e3a5f 0%, #2d5a87 100%);
  color: #fff;
  padding: 80px 24px 60px;
  text-align: center;
}

.about-hero-content {
  max-width: 720px;
  margin: 0 auto;
}

.about-hero h1 {
  font-size: 2.25rem;
  font-weight: 700;
  margin-bottom: 1rem;
}

.about-hero .lead {
  font-size: 1.3125rem;
  line-height: 1.6;
  opacity: 0.95;
}

.about-story {
  padding: 60px 24px;
  background: #fff;
}

.about-story-inner {
  max-width: 680px;
  margin: 0 auto;
}

.about-story h2 {
  font-size: 1.625rem;
  font-weight: 600;
  color: #1a1a1a;
  margin-bottom: 1.25rem;
}

.about-story p {
  font-size: 1.125rem;
  line-height: 1.7;
  color: #333;
  margin-bottom: 1rem;
}

.about-story p:last-child {
  margin-bottom: 0;
}

.about-story a {
  color: #2563eb;
  font-weight: 500;
  text-decoration: none;
}

.about-story a:hover {
  text-decoration: underline;
}

.about-cta {
  padding: 48px 24px;
  text-align: center;
  background: #fff;
}

.about-cta .btn {
  display: inline-block;
  background-color: #2563eb;
  color: #fff;
  font-weight: 600;
  padding: 14px 28px;
  border-radius: 8px;
  text-decoration: none;
  transition: background-color 0.2s;
}

.about-cta .btn:hover {
  background-color: #1d4ed8;
}

@media (min-width: 768px) {
  .about-hero h1 {
    font-size: 2.75rem;
  }

  .about-hero .lead {
    font-size: 1.375rem;
  }
}
</style>
